export default __webpack_public_path__ + "static/media/Arm_left.fb1bed10.svg";